<template>
  <div class="all">
    <el-table stripe :data="tableData">
      <el-table-column show-overflow-tooltip prop="title" label="标题" width="480">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top" width="480">
            <p>{{ scope.row.content }}</p>
            <div slot="reference" class="name-wrapper">
              {{ scope.row.title }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="category" label="分类" width="180" sortable :filters="filterCategory" :filter-method="filterHandler">
      </el-table-column>
      <el-table-column prop="creator" label="创建人" width="120" sortable :filters="filterCreator" :filter-method="filterHandler">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100" sortable :filters="filterStatus" :filter-method="filterHandler">
        <template slot-scope="scope">
          <el-tag size="medium" :type="status2Tag(scope.row.status)">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="modified" label="更新日期" width="160" sortable>
      </el-table-column>
      <!-- <el-table-column label="操作" width="120">
      <template slot-scope="scope">
        <el-button size="mini" @click="handleView(scope.$index, scope.row)">查看详情</el-button>
      </template>
    </el-table-column>       -->
    </el-table>
  </div>
</template>

<script>
import { get } from 'axios';
export default {
  data() {
    return {
      dialogVisible: false,
      user: window.globalData?.user || {},
      storyData: [],
      tableData: [],
      filterCategory: [],
      filterCreator: [],
      filterStatus: [],
      globalData: {}
    }
  },
  methods: {
    status2Tag(status) {
      console.log("status2Tag: " + status)
      const tagMap = new Map()
      this.globalData.config.tagList.forEach(element => {
        tagMap.set(element.value, element.label)
      })
      return tagMap.get(status)
    },
    filterHandler(value, row, column) {
        const property = column['property'];
        return row[property] === value;
      }    
  },
  async mounted() {
    this.globalData = window.globalData;

    let { data } = await get('api/opinions/list')
    if (data.code === 0) {
      console.log(data)
      this.storyData = data.data || []

      const categoryMap = new Map()
      this.globalData.config.categoryList.forEach(element => {
        categoryMap.set(element.value, element.label)
      })

      const statusMap = new Map()
      this.globalData.config.statusList.forEach(element => {
        statusMap.set(element.value, element.label)
      })

      const categorySet = new Set()
      const creatorSet = new Set()
      const statusSet = new Set()

      this.storyData.forEach(element => {
        var item = { id: element.id, title: element.title, content: element.text, category: categoryMap.get(element.category), creator: element.creatorName, status: statusMap.get(element.status), modified: element.modified }
        this.tableData.push(item)

        categorySet.add(item.category)
        creatorSet.add(item.creator)
        statusSet.add(item.status)  
      });

      // console.log(categorySet)
      console.log(this.tableData)

      // this.filterCategory.push("test")

      // console.log(this.filterCategory)

      const cates = []
      categorySet.forEach(function (cate) {
        var item = { text: cate, value: cate }
        console.log(item)
        cates.push(item)
      })

      const creators = []
      creatorSet.forEach(function (creator) {
        var item = { text: creator, value: creator }
        console.log(item)
        creators.push(item)
      })      

      const statusArray = []
      statusSet.forEach(function (status) {
        var item = { text: status, value: status }
        console.log(item)
        statusArray.push(item)
      })      

      this.filterCategory = cates
      this.filterCreator = creators
      this.filterStatus = statusArray

      // console.log(this.filterCategory)
    } else {
      this.$message.error('读取列表失败!')
    }
  }
}
</script>

<style>
.all {
  padding: 40px;
  width: 1040px;
}
</style>
